import {Component, ElementRef, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {ReactBaseComponent} from '../../../react/base/react-base.component';
import {PriceDebugConsole} from '../../../react/price/debug-console/price-debug-console';
import {PriceDebugMessageStore} from '../../../react/price/debug-console/price-debug-message-store';
import {StreamDataService} from '../../main/stream/stream-data.service';

const containerElementName = 'reactPriceDebugConsole';

@Component({
  selector: 'price-debug-console',
  template: `<div #${containerElementName}></div>`,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PriceDebugConsoleComponent extends ReactBaseComponent {
  @ViewChild(containerElementName, {static: false}) containerRef: ElementRef;
  private readonly store: PriceDebugMessageStore;

  constructor(streamDataService: StreamDataService) {
    super();
    this.store = new PriceDebugMessageStore(streamDataService);
  }

  protected override renderComponent() {
    return <PriceDebugConsole store={this.store}/>;
  }
}
